<div class="txt-input borderGreen"
 style="background-image: url(assets/images/popup.png); background-repeat: no-repeat;">
    <span style="color: black; font-size: 15px; font-weight:bold ;" > {{message}} </span>
</div>




